import { Pipe, PipeTransform } from '@angular/core';
import { StatusSprawy } from '@interfaces/wnioski/enums/sprawy/sprawy-studentow/status-sprawy.enum';

@Pipe({
  name: 'statusSprawy',
})
export class StatusSprawyPipe implements PipeTransform {
  transform(value: StatusSprawy): string {
    const {
      WTrakcieWeryfikacji,
      OczekujeNaRozpatrzenie,
      WTrakcieRozpatrywania,
      OczekujeNaWydanieDecyzji,
      OczekujeNaPodpisPostanowienia,
      OczekujeNaPotwierdzenieOtrzymaniaPostanowienia,
      DoUmorzenia,
      OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania,
      OczekujeNaPotwierdzenieOtrzymaniaDecyzjiOUmorzeniuPostepowania,
      WTrakcieWeryfikacjiPoZawiadomieniu,
      WszczetoPostepownieStwierdzonoBrakiFormalne,
      SprawaZamknietaWycofanoPodnie,
      WPrzygotowaniuDoDrugiejInstancji,
      RozpatrywanieOdwolania,
      OczekujeNaWydanieDecyzjiOdwolanie,
      WPrzygotowaniuDecyzjiZmieniajacej,
      OczekujeNaWydanieDecyzjiZmieniajacej,
      Zarchiwizowano,
      DecyzjaOPonowneRozpatrzenieWPrzygotowaniu,
      OczekujeNaWydanieDecyzjiOPonowneRozpatrzenie,
      WygenerowanoSzablonDecyzjiZmieniajacej,
      SprawaZostawionaBezRozpoznania,
      Nowa,
      Przydzielono,
      WydanoDecyzje,
      DoreczonoDecyzje,
      UprawomocnionoDecyzje,
      WygenerowanoSzablonPostanowienia,
      WydanoPostanowienie,
      DoreczonoPostanowienie,
      WydanoDecyzjeOUmorzeniuPostepowania,
      DoreczonoDecyzjeOUmorzeniuPostepowania,
      UprawomocnionoDecyzjeOUmorzeniuPostepowania,
      PrzydzielonoDoSprawyZUrzeduPracownika,
      ZawiadomienieOWszczeciu,
      WplyneloOdwolanie,
      PrzekazanoDoDrugiejInstancji,
      WydanoDecyzjeOdwolanie,
      DecyzjaDoreczonaOdwolanie,
      DecyzjaPrawomocnaOdwolanie,
      WydanoDecyzjeZmieniajaca,
      DoreczonoDecyzjeZmieniajaca,
      UprawomocnionoDecyzjeZmieniajaca,
      WplynalWniosekOPonowneRozpatrzenie,
      WydanoDecyzjeOPonowneRozpatrzenie,
      DecyzjaOPonowneRozpatrzenieDoreczona,
      DecyzjaOPonowneRozpatrzeniePrawomocna,
    } = StatusSprawy;

    switch (value) {
      case Nowa:
      case Przydzielono:
      case WydanoDecyzje:
      case DoreczonoDecyzje:
      case UprawomocnionoDecyzje:
      case WygenerowanoSzablonPostanowienia:
      case WydanoPostanowienie:
      case DoreczonoPostanowienie:
      case WydanoDecyzjeOUmorzeniuPostepowania:
      case DoreczonoDecyzjeOUmorzeniuPostepowania:
      case UprawomocnionoDecyzjeOUmorzeniuPostepowania:
      case PrzydzielonoDoSprawyZUrzeduPracownika:
      case ZawiadomienieOWszczeciu:
      case WplyneloOdwolanie:
      case PrzekazanoDoDrugiejInstancji:
      case WydanoDecyzjeOdwolanie:
      case DecyzjaDoreczonaOdwolanie:
      case DecyzjaPrawomocnaOdwolanie:
      case WydanoDecyzjeZmieniajaca:
      case DoreczonoDecyzjeZmieniajaca:
      case UprawomocnionoDecyzjeZmieniajaca:
      case WplynalWniosekOPonowneRozpatrzenie:
      case WydanoDecyzjeOPonowneRozpatrzenie:
      case DecyzjaOPonowneRozpatrzenieDoreczona:
      case DecyzjaOPonowneRozpatrzeniePrawomocna:
        return 'bg-success';
      case WTrakcieWeryfikacji:
      case WTrakcieRozpatrywania:
      case OczekujeNaRozpatrzenie:
      case OczekujeNaWydanieDecyzji:
      case OczekujeNaPodpisPostanowienia:
      case OczekujeNaPotwierdzenieOtrzymaniaPostanowienia:
      case OczekujeNaPodpisDecyzjiOUmorzeniuPostepowania:
      case OczekujeNaPotwierdzenieOtrzymaniaDecyzjiOUmorzeniuPostepowania:
      case WTrakcieWeryfikacjiPoZawiadomieniu:
      case WszczetoPostepownieStwierdzonoBrakiFormalne:
      case WPrzygotowaniuDoDrugiejInstancji:
      case RozpatrywanieOdwolania:
      case OczekujeNaWydanieDecyzjiOdwolanie:
      case WPrzygotowaniuDecyzjiZmieniajacej:
      case OczekujeNaWydanieDecyzjiZmieniajacej:
      case Zarchiwizowano:
      case DecyzjaOPonowneRozpatrzenieWPrzygotowaniu:
      case OczekujeNaWydanieDecyzjiOPonowneRozpatrzenie:
      case WygenerowanoSzablonDecyzjiZmieniajacej:
        return 'bg-warning text-body';
      case DoUmorzenia:
      case SprawaZamknietaWycofanoPodnie:
      case SprawaZostawionaBezRozpoznania:
        return 'bg-danger';
      default:
        return 'bg-info';
    }
  }
}
